/*============================================================================
Ajax the add to cart experience by revealing it in a side drawer
Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
(c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

This file includes:
- Basic Shopify Ajax API calls
- Ajax cart plugin

This requires:
- jQuery 1.8+
- handlebars.min.js (for cart template)
- modernizer.min.js
- snippet/ajax-cart-template.liquid

Customized version of Shopify's jQuery API
(c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if (typeof ShopifyAPI === "undefined") {
  ShopifyAPI = {};
}

/*============================================================================
API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if (typeof attribute !== "string") {
    attribute += "";
    if (attribute === "undefined") {
      attribute = "";
    }
  }
  return jQuery.trim(attribute);
}

/*============================================================================
API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function (note, callback) {
  var params = {
    type: "POST",
    url: "/cart/update.js",
    data: "note=" + attributeToString(note),
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      } 
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval("(" + XMLHttpRequest.responseText + ")");
  if (!!data.message) {
    alert(data.message + "(" + data.status + "): " + data.description);
  }
};

/*============================================================================
POST to cart/add.js returns the JSON of the cart
- Allow use of form element instead of just id
- Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: jQuery(form).serialize(),
    dataType: "json",
    success: function (line_item) {
      if (typeof callback === "function") {
        callback(line_item, form);
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (typeof errorCallback === "function") {
        errorCallback(XMLHttpRequest, textStatus);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    },
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  jQuery.getJSON("/cart.js", function (cart, textStatus) {
    if (typeof callback === "function") {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
  var params = {
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + quantity + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
};

/*============================================================================
                                                                                                                                                                                                                                                                                                                                                                                                                        Ajax Shopify Add To Cart
                                                                                                                                                                                                                                                                                                                                                                                                                        ==============================================================================*/
var ajaxCart = (function (module, $) {
  "use strict";

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer,
    $addToCart,
    $cartCountSelector,
    $cartCostSelector,
    $cartContainer,
    $drawerContainer;

  // Private functions
  var updateCountPrice,
    formOverride,
    itemAddedCallback,
    itemErrorCallback,
    cartUpdateCallback,
    buildCart,
    cartCallback,
    adjustCart,
    adjustCartCallback,
    createQtySelectors,
    qtySelectors,
    validateQty,
    handleGiftAddonAfterMainAdd,
    showPopupMessage,
    addGiftVariant,
    isAddingGift;

  /*============================================================================
                                                                                                                                                                                                                                                                                                                                                                                                                                                Initialise the plugin and define global options
                                                                                                                                                                                                                                                                                                                                                                                                                                                  ==============================================================================*/
  init = function (options) {
    // Default settings
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: "#CartContainer",
      addToCartSelector: ".enj-add-to-cart-btn",
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: "$",
      disableAjaxCart: false,
      enableQtySelectors: true,
    };



    isAddingGift = false;
    $body = $("body");
    // Listen after cart is rebuilt (also fires on popup add)
    $body.on("ajaxCart.afterCartLoad", function (evt, cart) {

                // Handle gift add button inside mini cart
        $body.on("click", '[data-gift-action="add"]', function (e) {
            console.log('btn clicked..'); 
        e.preventDefault();
        var $btn = $(this);
        var $wrap = $btn.closest("[data-gift-addon]");
        if (!$wrap.length) return;

        var giftId = parseInt($wrap.data("gift-variant-id"), 10);
        if (!giftId) return;

        // Prevent double clicks
        if ($btn.hasClass("is-loading")) return;
        $btn.addClass("is-loading").prop("disabled", true);

        ShopifyAPI.getCart(function (cart) {
            var hasGift =
            cart.items &&
            cart.items.some(function (it) {
                return it.variant_id == giftId;
            });

            if (hasGift) {
            showPopupMessage("notice", "Gift box is already in your cart.");
            $btn.removeClass("is-loading").prop("disabled", false);
            return;
            }

            addGiftVariant(
            giftId,
            function () {
                showPopupMessage("success", "Gift box added to your cart.");
                ShopifyAPI.getCart(cartUpdateCallback);
                $btn.removeClass("is-loading").prop("disabled", false);
            },
            function () {
                showPopupMessage("error", "Unable to add gift box.");
                $btn.removeClass("is-loading").prop("disabled", false);
            }
            );
        });
        });


    
        syncGiftWidgetVisibility(cart);
      var $giftCheckbox = $('input[name="gift-box-addon"]');
      if (!$giftCheckbox.length) return;

      var giftId = parseInt($giftCheckbox.first().val(), 10);
      if (!giftId) return;

      var hasGift =
        cart.items &&
        cart.items.some(function (it) {
          return it.variant_id == giftId;
        });

      if (hasGift) {
        $(".ai-gift-box-container, [class*='ai-gift-box-container']").hide();
      } else {
        $(".ai-gift-box-container, [class*='ai-gift-box-container']").show();
      }
    });

    
    // Gift add button in mini cart
    // $body.on("click", "[data-gift-addon] [data-gift-action='add']", function (e) {
    // e.preventDefault();

    // var $wrap = $(this).closest("[data-gift-addon]");
    // var giftId = parseInt($wrap.attr("data-gift-variant-id"), 10);
    // if (!giftId) return;

    // // prevent double clicks
    // if (isAddingGift) return;

    // ShopifyAPI.getCart(function (cart) {
    //     var hasGift =
    //     cart.items &&
    //     cart.items.some(function (it) {
    //         return it.variant_id == giftId;
    //     });

    //     if (hasGift) {
    //     showPopupMessage("notice", "Gift box is already in your cart.");
    //     return;
    //     }

    //     isAddingGift = true;

    //     addGiftVariant(
    //     giftId,
    //     function () {
    //         // reload drawer cart + show message
    //         showPopupMessage("success", "Gift box added to your cart.");
    //         ShopifyAPI.getCart(cartUpdateCallback);
    //         isAddingGift = false;
    //     },
    //     function () {
    //         isAddingGift = false;
    //         showPopupMessage("error", "Could not add gift box. Please try again.");
    //     }
    //     );
    // });
    // });


    
    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    // General Selectors
    $body = $("body");

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
    // check if gift box is added.  

    ShopifyAPI.getCart(function(cart){
    syncGiftWidgetVisibility(cart);
    });

  };

  loadCart = function () {
    $body.addClass("drawer--is-loading");
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass("hidden-count");
      $(".product-popup").find(".product-item-count").html(cart.item_count);
      if (cart.item_count === 0) {
        $cartCountSelector.addClass("hidden-count");
        $(".js-number-cart").removeClass("active");
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(
        Shopify.formatMoney(cart.total_price, settings.moneyFormat)
      );
    }
  };
  // new heloper functions
function syncGiftWidgetVisibility(cart) {
  var $giftCheckbox = $('input[name="gift-box-addon"]').first();
  if (!$giftCheckbox.length) return;

  var giftId = parseInt($giftCheckbox.val(), 10);
  if (!giftId) return;

  var hasGift = cart.items && cart.items.some(function(it){
    return it.variant_id == giftId;
  });

  // Your container class is dynamic, so target by "starts with"
  var $giftUI = $("[class^='ai-gift-box-container-'], [class*='ai-gift-box-container-']").closest("div");

  if (hasGift) {
    $giftUI.hide();
  } else {
    $giftUI.show();
  }
}

function openSideCart() {
$('.js-minicart.minicart').addClass('active');
}


    showPopupMessage = function (type, message) {
    // type: "success" | "notice" | "error"

    // Ensure side cart is open so message is visible
    $('.js-minicart.minicart').addClass('active');

    var $head = $(".mini-cart-head");
    if (!$head.length) return;

    // Create message container once
    var $msg = $head.find(".gift-addon-message");
    if (!$msg.length) {
    $head.append(
    '<div class="gift-addon-message" style="margin-top:8px; display:none;"></div>'
    );
    $msg = $head.find(".gift-addon-message");
    }

    $msg
    .removeClass("is-success is-notice is-error")
    .addClass(
    type === "success" ? "is-success" : type === "error" ? "is-error" : "is-notice"
    )
    .html(message)
    .stop(true, true)
    .fadeIn(150);

    // Auto hide
    clearTimeout(window.__giftAddonMsgTimer);
    window.__giftAddonMsgTimer = setTimeout(function () {
    $msg.fadeOut(200);
    }, 3000);
    };

  addGiftVariant = function (variantId, doneCb, errorCb) {
    return $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: "id=" + variantId + "&quantity=1",
      dataType: "json",
      success: function (line_item) {
        if (typeof doneCb === "function") doneCb(line_item);
      },
      error: function (xhr, textStatus) {
        if (typeof errorCb === "function") errorCb(xhr, textStatus);
      },
    });
  };

  handleGiftAddonAfterMainAdd = function (form) {
    // Look for your checkbox (you set: name="gift-box-addon" value="")
    var $checkbox = $(form).find('input[name="gift-box-addon"]');

    // If checkbox is not inside the form, fallback to page-level checkbox
    if (!$checkbox.length)
      $checkbox = $('input[name="gift-box-addon"]').first();
    if (!$checkbox.length) return;

    if (!$checkbox.is(":checked")) return;

    var giftId = parseInt($checkbox.val(), 10);
    if (!giftId) return;

    // Prevent loops if we are adding gift right now
    if (isAddingGift) return;

    ShopifyAPI.getCart(function (cart) {
      var hasGift =
        cart.items &&
        cart.items.some(function (it) {
          return it.variant_id == giftId;
        });

      if (hasGift) {
         console.log("Gift box is already in your cart");
        showPopupMessage("notice", "Gift box is already in your cart.");
        return;
      }

      isAddingGift = true;

      addGiftVariant(
        giftId,
        function (addedGift) {
          showPopupMessage("success", "Gift box added to your cart.");
           console.log("Gift box is adding in cart");
        //   ShopifyAPI.getCart(cartUpdateCallback);
        ShopifyAPI.getCart(function(cart){
            cartUpdateCallback(cart);             
            $(".js-minicart.minicart").addClass("active");
            });

          isAddingGift = false;
        },
        function (xhr) {
            isAddingGift = false;

            var msg = "";
            try {
                msg = JSON.parse(xhr.responseText || "{}").description || "";
            } catch(e) {}

            // ✅ Shopify limit message: treat as already in cart
            if (xhr.status === 422 && msg.toLowerCase().includes("maximum quantity")) {
                showPopupMessage("notice", "Gift box is already in your cart.");
                ShopifyAPI.getCart(cartUpdateCallback);
                return;
            }

            showPopupMessage("error", msg || "Could not add gift box. Please try again.");
            }

        // function (xhr) {
        //   isAddingGift = false;
        //   console.log("Gift box error ");
        //   showPopupMessage(
        //     "error",
        //     "Could not add gift box. Please try again."
        //   );
        // }
      );
    });
  };
  // new helper function ends here....
  formOverride = function () {
    $formContainer.on("submit", function (evt) {
      evt.preventDefault();
      var $addToCart_btn = $(this).find(settings.addToCartSelector);
      // Add class to be styled if desired
      $addToCart_btn.removeClass("is-added").addClass("is-adding");
      $addToCart_btn
        .find("i")
        .replaceWith(
          '<i class="enj-loader-add-to-cart fsz-unset"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg></i>'
        );

      // Remove any previous quantity errors
      $(".qty-error").remove();

      ShopifyAPI.addItemFromForm(
        evt.target,
        itemAddedCallback,
        itemErrorCallback
      );
    });
  };

  itemAddedCallback = function (product, form) {
    var $addToCart_btn = $(form).find(settings.addToCartSelector);
    $addToCart_btn.removeClass("is-adding").addClass("is-added");
    $addToCart_btn
      .find(".enj-loader-add-to-cart")
      .html(
        '<svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" height="400" width="400" xml:space="preserve" id="svg2" version="1.1"><metadata id="metadata8"><rdf:RDF><cc:Work rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/></cc:Work></rdf:RDF></metadata><defs id="defs6"/><g transform="matrix(1.3333333,0,0,-1.3333333,0,400)" id="g10"><g transform="scale(0.1)" id="g12"><path id="path14" style="/* fill:#231f20; */fill-opacity:1;fill-rule:nonzero;stroke:none;" d="M 2539.18,1385.02 C 2479.15,849.23 2004.9,434.289 1446.39,470.129 931.406,503.16 516.711,917.871 483.672,1432.85 c -38.359,597.88 439.844,1099.19 1029.878,1099.19 78.39,0 149.09,-7.24 218.27,-21.98 42.37,-9.03 86.4,4.1 116.99,34.78 v 0 c 71.82,72.04 34.9,194.92 -64.67,215.74 -88.86,18.58 -179.73,29.87 -270.59,29.87 -709.417,0 -1290.445,-581.02 -1290.445,-1290.45 0,-709.418 581.028,-1290.449 1290.445,-1290.449 661.24,0 1210.92,504.781 1282.54,1147.799 8.47,76.02 -50.73,142.65 -127.21,142.65 h -2.45 c -65.64,0 -119.94,-49.75 -127.25,-114.98 z M 894.004,1654.48 v 0 c -49.668,-49.89 -49.578,-130.58 0.207,-180.36 L 1384.35,983.98 2584.51,2184.15 c 49.87,49.87 49.87,130.71 0,180.57 l -0.23,0.23 c -49.88,49.87 -130.74,49.85 -180.6,-0.03 L 1384.35,1344.99 1074.79,1654.67 c -49.94,49.95 -130.95,49.87 -180.786,-0.19"/></g></g></svg>'
      );

    $(".product-popup").find(".product-name").html(product.title);
    $(".product-popup")
      .find(".product-price")
      .html(Shopify.formatMoney(product.price, settings.moneyFormat));
    $(".product-popup").find(".product-qty").html(product.quantity);
    $(".product-popup")
      .find(".product-total")
      .html(Shopify.formatMoney(product.line_price, settings.moneyFormat));

    $(".product-popup").find(".product-image img").attr("src", product.image);

    // showPopup('.product-popup');

    openSideCart();
    ShopifyAPI.getCart(cartUpdateCallback);
    // adding gift inside the cart drawer..
    // handleGiftAddonAfterMainAdd(form);

    // If gift is checked, handleGiftAddonAfterMainAdd will refresh cart when done.
    // Otherwise refresh cart now.
    var $cb = $(form).find('input[name="gift-box-addon"]');
    if (!$cb.length) $cb = $('input[name="gift-box-addon"]').first();

    if ($cb.length && $cb.is(":checked")) {
    handleGiftAddonAfterMainAdd(form);
    } else {
    ShopifyAPI.getCart(cartUpdateCallback);
    $(".js-minicart.minicart").addClass("active"); // open drawer
    }


    const eventData = { productId: 123, quantity: 1 };

    const customEvent = new CustomEvent("xxxx", {
      detail: eventData,
    });

    document.dispatchEvent(customEvent);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval("(" + XMLHttpRequest.responseText + ")");
    $addToCart.removeClass("is-adding is-added");
    $addToCart.find(".enj-loader-add-to-cart").remove();

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after(
          '<div class="errors qty-error">' + data.description + "</div>"
        );
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer.append("<p>" + "Your cart is currently empty." + "</p>");
      cartCallback(cart);
      return;
      $(".js-number-cart").removeClass("active");
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $("#CartTemplate").html(),
      template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
      if (cartItem.image != null) {
        var prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, "_small$1")
          .replace("http:", "");
      } else {
        var prodImg =
          "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        variant_id: cartItem.variant_id,
        line: index + 1,
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
      };

      items.push(item);
    });
        // ---------- Gift box runtime flags ----------
        var giftBox = window.GIFT_BOX || {};
        var giftVariantId = giftBox.variant_id || 0;

        var hasGift = false;
        if (giftVariantId && cart.items && cart.items.length) {
        hasGift = cart.items.some(function (it) {
            return it.variant_id == giftVariantId;
        });
        }

    // Gather all cart data and add to DOM
    // data = {
    //   items: items,
    //   note: cart.note,
    //   totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
    //   gift_variant_id: parseInt(window.GIFT_BOX_VARIANT_ID || 0, 10),
    //   has_gift:
    //     (function () {
    //     var g = parseInt(window.GIFT_BOX_VARIANT_ID || 0, 10);
    //     if (!g || !cart.items) return false;
    //     return cart.items.some(function (it) { return parseInt(it.variant_id, 10) === g; }); })() 
    
    //     };



        data = {
            items: items,
            note: cart.note,
            totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),

            // ----- gift box -----
            gift_enabled: giftBox.enabled === true,
            gift_variant_id: giftVariantId,
            has_gift: hasGift,

            gift_label: giftBox.label,
            gift_price_label: giftBox.price_label,
            gift_price: giftBox.default_price,
            gift_image: giftBox.image_url
            };



    $(".product-popup")
      .find(".product-total-cart")
      .html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));

    $cartContainer.append(template(data));

    cartCallback(cart);
    $(".js-number-cart").addClass("active");
  };

  cartCallback = function (cart) {
    $body.removeClass("drawer--is-loading");
    $body.trigger("ajaxCart.afterCartLoad", cart);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on("click", ".ajaxcart__qty-adjust", function () {
      var $el = $(this),
        line = $el.data("line"),
        $qtySelector = $el.siblings(".ajaxcart__qty-num"),
        qty = parseInt($qtySelector.val().replace(/\D/g, ""));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass("ajaxcart__qty--plus")) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    $body.on("click", ".remove-product", function () {
      var $el = $(this),
        line = $el.data("line"),
        qty = 0;
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on("submit", "form.ajaxcart", function (evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on("focus", ".ajaxcart__qty-adjust", function () {
      var $el = $(this);
      setTimeout(function () {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass(
        "is-loading"
      );

      if (qty === 0) {
        $row.parent().addClass("is-removed");
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function () {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on("change", 'textarea[name="note"]', function () {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function (cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function () {
      ShopifyAPI.getCart(buildCart);
    }, 150);
  };

  createQtySelectors = function () {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function () {
        var $el = $(this),
          currentQty = $el.val();

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#AjaxQty").html(),
          template = Handlebars.compile(source),
          data = {
            id: $el.data("id"),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function () {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function () {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr("name"),
          inputId = $el.attr("id");

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#JsQty").html(),
          template = Handlebars.compile(source),
          data = {
            id: $el.data("id"),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId,
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $(".js-qty__adjust").on("click", function () {
        var $el = $(this),
          id = $el.data("id"),
          $qtySelector = $el.siblings(".js-qty__num"),
          qty = parseInt($qtySelector.val().replace(/\D/g, ""));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass("js-qty__adjust--plus")) {
          qty += 1;
          console.log(qty);
          updatePricingQty(qty);
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
          updatePricingQty(qty);
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart,
  };

  return module;
})(ajaxCart || {}, jQuery);
